import React, { useState, useEffect } from 'react';
import { styled } from 'twin.macro';

// Styled div for the fade-in effect
const FadeInWrapper = styled.div<{ visible: boolean; zIndex?: string }>`
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  transition: opacity 0.3s ease-in-out;
  ${({ zIndex }) => zIndex && `z-index: ${zIndex};`}
  position: relative;
`;

const FadeInComponent = ({
  children,
  delay = 300,
  zIndex,
}: {
  children: React.ReactNode;
  delay?: number;
  zIndex?: string;
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Set the component visible after a short delay (e.g., 300ms)
    const timer = setTimeout(() => {
      setVisible(true);
    }, delay);

    // Cleanup function to clear the timer
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <div>
      {React.Children.map(children, (child, index) => (
        <FadeInWrapper
          visible={visible}
          zIndex={zIndex}
          style={{ transitionDelay: `${index * 100}ms` }}
        >
          {child}
        </FadeInWrapper>
      ))}
    </div>
  );
};

export default FadeInComponent;
